function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#097fac",
  d: "M20.7809 18.5589l-4.8764-4.8772-.0235.0235c.9862-1.4133 1.5673-3.1285 1.5673-4.981C17.4483 3.9061 13.5429 0 8.724 0 3.907 0 0 3.9061 0 8.7241s3.9069 8.7242 8.7241 8.7242c1.8533 0 3.5686-.5834 4.9811-1.5673l-.0235.0235 4.8772 4.8764c.3057.3072.7093.4605 1.1114.4605.402 0 .8041-.1533 1.1106-.4605.6137-.6137.6137-1.6098 0-2.222M8.7241 15.1732c-3.5556 0-6.4482-2.8926-6.4482-6.4483s2.8926-6.449 6.4482-6.449c3.5565 0 6.4483 2.8926 6.4483 6.4482 0 3.5557-2.8926 6.449-6.4483 6.449"
});

var SvgLoupe = function SvgLoupe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoupe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loupe.c3913230.svg";
export { ForwardRef as ReactComponent };